export const recipeSelected = recipe => ({
  type: 'Recipe Selected',
  data: {
    recipe,
  },
});

export const recipeUnselected = recipe => ({
  type: 'Recipe Unselected',
  data: {
    recipe,
  },
});

export const recipesShown = (
  selected_recipes,
  unselected_recipes,
  excluded_recipes,
) => ({
  type: 'Recipes Shown',
  data: {
    selected_recipes,
    unselected_recipes,
    excluded_recipes,
  },
});

export const userContinuesToCheckoutEvent = selectedRecipes => ({
  type: 'User continues from baked recipes',
  data: {
    recipes_count: selectedRecipes.length,
    recipes_selected: selectedRecipes,
  },
});

export const userViewBakedRecipeScreen = numAvailableRecipes => ({
  type: 'User views baked recipes page',
  data: {
    available_recipes: numAvailableRecipes,
  },
});

export const userExpandsBakedRecipeDetails = recipe => ({
  type: 'User expands baked recipe details',
  data: {
    recipe,
  },
});
